module.exports = __webpack_public_path__ + "img/pacific.15b3bb91.png";